"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bell = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const bell = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'bell-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4.25 8.75C4.25 5.57436 6.82436 3 10 3C13.1756 3 15.75 5.57436 15.75 8.75V10.0368C15.75 11.0058 16.0368 11.9532 16.5743 12.7594L17.624 14.334C17.7775 14.5641 17.7918 14.86 17.6613 15.1039C17.5307 15.3478 17.2766 15.5 17 15.5H12.7388C12.6125 16.9016 11.4345 18 10 18C8.56549 18 7.38752 16.9016 7.26121 15.5H3C2.7234 15.5 2.46926 15.3478 2.33875 15.1039C2.20823 14.86 2.22254 14.5641 2.37596 14.334L3.42568 12.7594C3.96318 11.9532 4.25 11.0058 4.25 10.0368V8.75ZM8.77501 15.5C8.89082 16.0706 9.39526 16.5 10 16.5C10.6047 16.5 11.1092 16.0706 11.225 15.5H8.77501ZM10 4.5C7.65279 4.5 5.75 6.40279 5.75 8.75V10.0368C5.75 11.302 5.37552 12.5388 4.67375 13.5915L4.40139 14H15.5986L15.3263 13.5915C14.6245 12.5388 14.25 11.302 14.25 10.0368V8.75C14.25 6.40279 12.3472 4.5 10 4.5Z', fill: '#4B5563' })));
};
exports.bell = bell;
